// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3Tg5J","author":"Table_author__3sepr","authorImage":"Table_authorImage__1EMdT","unreadRow":"Table_unreadRow__mkdQe"};